import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { supportCourseAxios } from "./axios";
import type { TGetSupportCourse } from "./getSupportCourse";

export interface IPostAddWorkshopsParticipants {
  participants: ObjectId[];
}

export const usePostAddWorkshopsParticipants = () => {
  const [state, execute, cancel] = supportCourseAxios<TGetSupportCourse, IPostAddWorkshopsParticipants, unknown>(
    {
      url: "/supportCourses",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: ObjectId, data: IPostAddWorkshopsParticipants) => {
      return execute({
        url: `/supportCourses/${id}/addWorkshopsParticipants`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
